import React from 'react'

function Spinner() {
    return (
        <div className='spinnerHolder ml-1 center'>
            <div className="spinner"></div>
        </div>
    )
}

export default Spinner;
